import { useMutation } from '@apollo/client';
import { UpsertTeamMutation } from '../../mutations';
import { MyTeamsQuery } from '../../queries';
import NewTabAnchor from '../basics/NewTabAnchor';
import TeamForm from '../team/TeamForm';

const TeamContent = ({ team, onCompleted }) => {
  const [upsertTeam] = useMutation(UpsertTeamMutation, {
    refetchQueries: [
      {
        query: MyTeamsQuery,
      },
    ],
    onCompleted: ({ upsertTeam: { result } }) => {
      if (result) {
        onCompleted(result);
      }
    },
  });
  return (
    <>
      <h2 className="font-weight-bold mb-3">Get started by creating a team</h2>
      <div className="mb-1">
        An Overyield team makes it easy to share and co-create farm projects.
        You can be a team of one, or add unlimited collaborators.
      </div>
      <TeamForm
        submitButtonText="Next: Select your plan"
        submitMutation={upsertTeam}
        resource={team}
        showLabels={false}
      />
      <div className="mt-4">
        Want to learn more before creating a team?{' '}
        <NewTabAnchor href="https://propagategroup.typeform.com/to/Vwk5EBOP">
          Contact us.
        </NewTabAnchor>
      </div>
    </>
  );
};

export default TeamContent;
